// extracted by mini-css-extract-plugin
module.exports = {"devicesButton":"Devices_devicesButton__6T7BO"};